/** Email Validation issue
 * https://github.com/jquense/yup/issues/507
 * */

/**
 * Custom regular expression to validate form fields
 * restrictSpecialCharacter from entering into field,
 * Should start with number or text, no special
 * characters allowed
 * @param allowNumericsWithoutDecimals: Valid number should be from [0-9], decimals not allowed
 */

export const REG_EX = {
  cocNumber: /^(?!00)[0-9]{8}$/,
  email: /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i,
  restrictSpecialCharacter: /^[a-zA-Z\d][\w\d\s]*$/,
  postalCode: /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i,
  allowNumericsWithoutDecimals: /^[+-]?(\d+)$/,
  dutchTelephoneNumber: /^(^\+?[0-9]{2}|^\+[0-9]{2}\(0\)|^\(\+[0-9]{2}\)\(0\)|^00[0-9]{2}|^0)([0-9]{9}$|[0-9\-\s]{10}$)$/,
  allowOnlyAlphabets: /^[a-zA-Z\s]+$/,
  alphabetsDigitsAndSpecialCharacters: /^[a-zA-Z\d\s.-]+$/,
  percentage: /^(100(\.00?)?|\d{1,2}(\.\d{1,2})?)$/,

  // Belgium REGEX
  cocNumberBelgium: /^\d{10}$/,
  postalCodeBelgium: /^\d{4}$/,
  belgiumTelephoneNumber: /^[a-zA-Z0-9+]{11,16}$/,
  vatNumberBelgium: /^BE0\d{9}$/i,
};

/**
 * Common validtion messages to be shown
 * throughout the applicatiom when
 * required fields have an error
 */
export const VALIDATION_PROPERTIES = {
  required: 'Verplicht',
  invalid: 'Ongeldige invoer',
  selectOne: 'Maak een keuze',
  maxAllow50characters: 'Maximaal 50 tekens toegestaan',
  cocNumber: 'Moet exact 8 cijfers bevatten en mag niet beginnen met "00"',
  noSpecialCharactersAllowed: 'Geen speciale karakters toegestaan',

  // Belgium Validation
  cocNumberBelgium: 'Moet exact 10 cijfers bevatten',
};

export const isValidNumber = (val) => REG_EX.allowNumericsWithoutDecimals.test(val);

export const isValidReductionPercentage = (val) => REG_EX.percentage.test(val);
